<div class="preview-head">
    <div class="header-title truncate">{{record.title}}</div>
	<div class="preview-options">
		<span class="fa fa-chevron-down pointMe" [hidden]="!record['id']" aria-hidden="true" (click)="minimized = !minimized" title="Minimize the Record Preview"></span>
		<span class="glyphicon glyphicon-remove pointMe" aria-hidden="true" (click)="close()" title="Close Record Preview"></span>
	</div>
</div>

<div class="preview-body" [hidden]="minimized">
	<div>
		<img title="{{record.title}}" 
			class="mapRecordPreviewImg img-responsive img-thumbnail center-block pointMe" 
			style="max-width: 150px;" 
			[src]="record.imgURL" 
			(click)="openRecord(record.id)" 
			alt="The thumbnail for {{record.title}}" />
	</div>
	<div>
		<div *ngFor='let field of Object.values(record.metadata)' class="row" style="margin-top:10px">
			<div class="col-xs-4 text-left"><h5 class="list-group-item-heading">{{field.label}}</h5></div>
			<div class="col-xs-8 text-left">
			<div *ngIf="field.links" >
	               <ul style="list-style:none; word-break:break-all; margin:0; padding:0;">
	                   <li *ngFor="let link of field.links">
	                       <a *ngIf="link.href.indexOf('file://')!=10" 
	                           href="{{link.href.replace('////','//')}}" 
	                           target="_blank" 
	                           (click)="displayLinkMsg(link.href)"> 
	                           {{link.name.replace('////','//')}} 
	                       </a>
	                   </li>
	               </ul>				 
			</div>                                            
	           <span *ngIf="!field.links"
	              class='dd-text-collapse'
	              ddTextCollapse
	              [ddTextCollapseMaxLength]="field.maxLength" 
	              [ddTextCollapseText]="field.value">
	           </span>
	           </div>			
		</div>
	</div>
</div>

<div class="preview-footer" [hidden]="minimized">
	<div *ngIf="record && projectedRecords[record.id] && !minimized" style="margin-bottom:10px">
	    <div class="row" [hidden]="!record.hasPages">
			<div class="class-xs-12">
				<nav aria-label="projectionPager">
					<ul class="pager">
						<li>
							<a (click)="prevProjectionPage()"
								[ngClass]="{'disabled' : currentProjectionPage <= 0}" 
								title="Prev projection page" 
								class="viewer-pager pointMe">
									{{LOCALIZATION.previous}}
							</a>
						</li>
						<li>
							<a (click)="nextProjectionPage()" 
								[ngClass]="{'disabled' : currentProjectionPage >= (record.projectedPages.length-1)}" 
								title="Next projection page" 
								class="viewer-pager pointMe">
									{{LOCALIZATION.next}}
							</a>
						</li>
					</ul>
				</nav>
			</div>
		</div>
		<div class="row">
			<div class="col-xs-12 clearfix">
				<label class="control control--checkbox">
					{{LOCALIZATION.toggleProjection}}
						<input
						  type="checkbox"
						  [(ngModel)]="projectedRecords[record.id][currentProjectionPage].toggled"
						  (change)="toggleProjection(record.id, currentProjectionPage)" />
					<div class="control__indicator" style="left:50% !important;"></div>
				</label>
			</div>
		</div>
		<div class="row">
			<div class="col-xs-12 clearfix">
				<p>{{LOCALIZATION.opacity}}</p>
				<input
				  type="range"
				  min="0"
				  max="1"
				  step="0.1"
				  (mousedown)="$event.stopPropagation()"
				  [(ngModel)]="projectedRecords[record.id][currentProjectionPage].opacity"
				  (change)="toggleOpacity(record.id, currentProjectionPage)" />
			</div>
		</div>
	</div>

	<span class="link pointMe" [hidden]="!record.geo" (click)="zoomToGeo()" title="Zoom To Record">{{LOCALIZATION.zoomTo}}</span>
	<span class="link pointMe" [hidden]="!record.hasProjected" (click)="projectToMap()" title="Project on Map">{{LOCALIZATION.project}}</span>
	<span class="link pointMe" [hidden]="!record.hasPages" (click)="expandRecord()" title="Display Points">{{LOCALIZATION.displayPoints}}</span>
	<span class="link pointMe" [hidden]="!record.hasFeatures" (click)="displayFeatures()" title="View Features on Map">{{LOCALIZATION.viewFeatures}}</span>
	<span class="link pointMe" [hidden]="!arcgis['featureLayer'] || arcgis['featureLayer']?.graphics?.length == 0" (click)="centerFeatureSet()" title="Zoom to the feature set extent">{{LOCALIZATION.zoomToFeature}}</span>
	
	<div style="margin-left:4px">
		<span style="float: left">{{pagingLabel}}</span>
		<div class="preview-pagination">
			<span [ngClass]="{'invisible' : !hasPrev}" (click)="prevPage()" class="fa fa-chevron-left pointMe" aria-hidden="true"></span>
			<span [ngClass]="{'invisible' : !hasNext}" (click)="nextPage()" class="fa fa-chevron-right pointMe" aria-hidden="true"></span>
		</div>
	</div>	
</div>
